import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-md flex-col gap-3 px-6 py-24 text-center">
      <h1 className="text-3xl font-semibold">Nothing here</h1>
      <p className="text-sm text-neutral-400">This snippet was deleted or never existed.</p>
      <Link to="/" className="text-sm text-brand-500 hover:underline">
        Go home
      </Link>
    </div>
  );
}
